/**
 * Type for the Table of Contents Selector Page Item
 * @param pageId - The unique page identifier
 * @param pageNumber - The page number
 * @param pageName - The Table of Contents entry defined Page Name (not TOC Page Name)
 * @param serialNo - The serial number of the page in the Table of Contents
 * @type
 */
export type TOCSelectorPageItem = {
  pageId: string;
  pageNumber: string;
  pageName: string;
  serialNo: number;
};

/**
 * Type for the View Type
 * @param viewType - The view type the User is currently on. Determines whether a TOC home link appears in the menu.
 * @type
 */
export enum ViewType {
  TOC_VIEW = 'tocView',
  PAGE_VIEW = 'pageView',
}

/**
 * Interface for the Table of Contents Selector
 * @param deckId - The unique deck identifier the page belongs to
 * @param tocPageItems - The list of pages in the deck that are part of the Table of Contents
 * @param viewType - The view type the User is currently on. Determines whether a TOC home link appears in the menu.
 * @param tocPageGroupLookup - A lookup table for pages grouped by their page status grouping ('active-approved', 'active-modified', or 'inactive')
 * @interface
 */
export interface TableOfContentsSelectorProps {
  deckId: string;
  tocPageItems: Array<TOCSelectorPageItem>;
  viewType: ViewType;
  tocPageGroupLookup?: Record<string, Set<string>>;
}
